import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/toaster";

import LandingPage from "@/pages/LandingPage";
import { LoginPage, SignupPage, GoogleCallback } from "@/pages/AuthPages";
import PricingPage from "@/pages/PricingPage";
import PurchasePage from "@/pages/PurchasePage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import RedeemPage from "@/pages/RedeemPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import HalftoneStudioPage from "@/pages/HalftoneStudioPage";
import AiVectorStudioPage from "@/pages/AiVectorStudioPage";
import WatermarkRemoverPage from "@/pages/WatermarkRemoverPage";
import PhotoUpgraderPage from "@/pages/PhotoUpgraderPage";
import { TermsPage, PrivacyPage, RefundPage } from "@/pages/LegalPages";
import { LearnHubPage, ArticlePage } from "@/pages/LearnPages";
import ServicesPage from "@/pages/ServicesPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieBanner from "@/components/CookieBanner";

function App() {
  React.useEffect(() => {
    document.title = "Furnace Design Lab";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/purchase" element={<PurchasePage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refund" element={<RefundPage />} />
            <Route path="/learn" element={<LearnHubPage />} />
            <Route path="/learn/:slug" element={<ArticlePage />} />
            <Route path="/services" element={<ServicesPage />} />

            <Route path="/redeem" element={<ProtectedRoute><RedeemPage /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/studio/halftone" element={<HalftoneStudioPage />} />
            <Route path="/studio/vector" element={<AiVectorStudioPage />} />
            <Route path="/studio/watermark" element={<WatermarkRemoverPage />} />
            <Route path="/studio/upgrade" element={<PhotoUpgraderPage />} />
          </Routes>
          <CookieBanner />
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
